require('./cardSelectorRadioButton.scss')

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
// const { Link } = require('react-router-dom');

// @components
const { CardSelectorItem } = require('./cardSelectorItem');

// @utils
const { formatText } = require('core/i18n').i18n;
const { recordLink } = require('utilities/tagging');

//@constants
const { CARD_SELECTION_ACTION_EVENT } = require('constants/tagging');
class CardSelectorRadioButton extends React.Component {
	constructor (props) {
		super(props)
		this.state = {
            firstSelected: true,
			selected: props.selected,
		}
	}

	componentWillReceiveProps (nextProps) {
		if (nextProps.selected !== this.state.selected) {
			this.setState({
                firstSelected: false,
				selected: nextProps.selected
			})
		}
	}

	handleOnChange = (c, i) => {
        const { lavandaEnabled } = this.props;
        const { firstSelected } = this.state;

        this.setState({selected: c.cardId})
		this.props.onChange(i)
        lavandaEnabled && !firstSelected && recordLink(window.utag_last_name, CARD_SELECTION_ACTION_EVENT, `${c.product.type}.${c.product.subtype}`);                 
	}

	getTitle = () => {
		const { cards } = this.props
        const cardsWithFunds = cards.filter(c => c.hasEnoughFunds).length
        const cardsWithoutFunds = cards.filter(c => !c.hasEnoughFunds).length

        if (cardsWithoutFunds <= 0 && cardsWithFunds >= 1) {
            return formatText("cardSelectorRadioButton-titleAllValid")
        }

        if (cardsWithoutFunds == 1 && cardsWithFunds == 0) {
            return formatText("cardSelectorRadioButton-titleOneInvalid")
        }

        if (cardsWithoutFunds > 1 && cardsWithFunds == 0) {
            return formatText("cardSelectorRadioButton-titleMultiInvalid")
        }

        if (cardsWithoutFunds >= 1 && cardsWithFunds >= 1) {
            return formatText("cardSelectorRadioButton-titleMultiValidAndInvalid")
        }
    }

    getSubtitle = () => {
        const { cards } = this.props
        const someSwitchedOff = cards.some(c => !c.control)

        if (someSwitchedOff)
            return formatText("cardSelectorRadioButton-someSwitchedOff")
        return null
    }

	renderItems = () => {

		const { cards, accountId, disablePreLeaveModal, lavandaEnabled} = this.props;
		const { selected } = this.state;
        const filteredCards = cards && Array.isArray(cards) && cards.filter(c => c.control && c.hasEnoughFunds)
        const selectedIndex = cards.findIndex(card => card.cardId === selected);
        let preselectedCardId;
        if (lavandaEnabled){
            preselectedCardId = filteredCards && filteredCards.length && filteredCards[0].cardId;
        }else{
            preselectedCardId = filteredCards && filteredCards.length == 1 && filteredCards[0].cardId
        }
		return (
            cards.map((c, i) => (
                <CardSelectorItem
                    preselected={preselectedCardId == c.cardId}
                    key={c.cardId}
                    accountId={accountId}
                    card={c}
                    active={selectedIndex == i}
                    index={i}
                    disabled={!c.control}
                    hasntEnoughFunds={!c.hasEnoughFunds}
                    onClick={() => this.handleOnChange(c, i)}
                    onToggleModal={() => this.handleOnToggleModal(c.cardId)}
                    disablePreLeaveModal={disablePreLeaveModal}
                />
            ))
        );
    }

	render () {
		const { subtitle, title } = this.props;
		const text = title || this.getTitle();
        const subText = subtitle || this.getSubtitle();

        return (
            <div className="row">
                <div className="col-md-12 card-selector-radio-button">
                    <h5 className="card-selector-radio-button__title">{text}</h5>
                    <h5 className="card-selector-radio-button__subtitle">{subText}</h5>
                    {this.renderItems()}
                </div>
            </div>
        );
	}
}

CardSelectorRadioButton.propTypes = {
	accountId: PropTypes.string,
	cards: PropTypes.array.isRequired,
    lavandaEnabled: PropTypes.bool.isRequired,
	onChange: PropTypes.func.isRequired,
	selected: PropTypes.number,
	title: PropTypes.string,
    subtitle: PropTypes.string,
    disablePreLeaveModal: PropTypes.func
}

module.exports.constructor = CardSelectorRadioButton;
module.exports.CardSelectorRadioButton = CardSelectorRadioButton
